import { DomainEvent } from "@/domains/events"

import type { NormalizedSwapQuote, SwapQuoteRequestData } from "./types"

export class SwapQuoteReceivedEvent extends DomainEvent {
  static readonly TYPE = "swap.quote-received"
  readonly type = SwapQuoteReceivedEvent.TYPE
  constructor(public readonly quote: NormalizedSwapQuote) {
    super()
  }
}

export class SwapQuotesRefreshedEvent extends DomainEvent {
  static readonly TYPE = "swap.quotes-refreshed"
  readonly type = SwapQuotesRefreshedEvent.TYPE
  constructor(public readonly quotes: NormalizedSwapQuote[]) {
    super()
  }
}

export class SwapApprovalStartedEvent extends DomainEvent {
  static readonly TYPE = "swap.approval-started"
  readonly type = SwapApprovalStartedEvent.TYPE
  constructor(public readonly quote: NormalizedSwapQuote) {
    super()
  }
}

export class SwapExecutionStartedEvent extends DomainEvent {
  static readonly TYPE = "swap.execution-started"
  readonly type = SwapExecutionStartedEvent.TYPE
  constructor(public readonly quote: NormalizedSwapQuote) {
    super()
  }
}

export class SwapCompletedEvent extends DomainEvent {
  static readonly TYPE = "swap.completed"
  readonly type = SwapCompletedEvent.TYPE
  constructor(
    public readonly quote: NormalizedSwapQuote,
    public readonly txHash: string,
  ) {
    super()
  }
}

export class SwapErrorEvent extends DomainEvent {
  static readonly TYPE = "swap.error"
  readonly type = SwapErrorEvent.TYPE
  constructor(
    public readonly quote: NormalizedSwapQuote | null,
    public readonly error: string,
  ) {
    super()
  }
}

export class SwapApprovalCompletedEvent extends DomainEvent {
  static readonly TYPE = "swap.approval-completed"
  readonly type = SwapApprovalCompletedEvent.TYPE
  constructor(
    public readonly quote: NormalizedSwapQuote,
    public readonly txHash: string,
  ) {
    super()
  }
}

export class SwapQuotesPausedEvent extends DomainEvent {
  static readonly TYPE = "swap.quotes-paused"
  readonly type = SwapQuotesPausedEvent.TYPE
  constructor(public readonly reason: "approval" | "execution") {
    super()
  }
}

export class SwapQuotesResumedEvent extends DomainEvent {
  static readonly TYPE = "swap.quotes-resumed"
  readonly type = SwapQuotesResumedEvent.TYPE
  constructor() {
    super()
  }
}

export class SwapQuoteRequestedEvent extends DomainEvent {
  static readonly TYPE = "swap.quote-requested"
  readonly type = SwapQuoteRequestedEvent.TYPE
  constructor(public readonly quoteRequest: SwapQuoteRequestData) {
    super()
  }
}

export class SwapQuoteRequestClearedEvent extends DomainEvent {
  static readonly TYPE = "swap.quote-request-cleared"
  readonly type = SwapQuoteRequestClearedEvent.TYPE
  constructor() {
    super()
  }
}

export class SwapAggregatorEnabledEvent extends DomainEvent {
  static readonly TYPE = "swap.aggregator-enabled"
  readonly type = SwapAggregatorEnabledEvent.TYPE
  constructor(public readonly aggregatorId: string) {
    super()
  }
}

export class SwapAggregatorDisabledEvent extends DomainEvent {
  static readonly TYPE = "swap.aggregator-disabled"
  readonly type = SwapAggregatorDisabledEvent.TYPE
  constructor(public readonly aggregatorId: string) {
    super()
  }
}
